import React from 'react';
import { Sparkles } from 'lucide-react';
import { TPL_SEVERITY_STYLE, type TplSeverity } from '../../services/tplSeverityStyles';

export interface DataflowCopilotAction {
  id: string;
  message: string;
  actionLabel: string;
  severity: TplSeverity;
  onAction?: () => void;
}

interface DataflowCopilotProps {
  actions: DataflowCopilotAction[];
  className?: string;
}

/** Copiloto DataFlow — recomenda ações, não apenas informa. */
export const DataflowCopilot: React.FC<DataflowCopilotProps> = ({ actions, className = '' }) => {
  if (actions.length === 0) return null;

  return (
    <section
      className={`rounded-lg border border-violet-200 bg-gradient-to-br from-violet-50/80 to-white dark:border-violet-900/50 dark:from-violet-950/30 dark:to-slate-950 ${className}`}
    >
      <div className="flex items-center gap-1.5 border-b border-violet-100 px-3 py-2 dark:border-violet-900/40">
        <Sparkles size={14} className="text-violet-600 dark:text-violet-400" />
        <h4 className="text-[10px] font-bold uppercase tracking-wide text-violet-800 dark:text-violet-300">
          Copiloto DataFlow — ações recomendadas
        </h4>
      </div>
      <ul className="divide-y divide-violet-100 dark:divide-violet-900/30">
        {actions.map((action) => {
          const style = TPL_SEVERITY_STYLE[action.severity];
          return (
            <li key={action.id} className="flex flex-wrap items-center justify-between gap-2 px-3 py-2.5">
              <p className={`min-w-0 flex-1 text-[11px] font-medium ${style.text}`}>{action.message}</p>
              {action.onAction && (
                <button
                  type="button"
                  onClick={action.onAction}
                  className="shrink-0 rounded-md border border-violet-300 bg-white px-2.5 py-1 text-[10px] font-bold uppercase tracking-wide text-violet-700 transition-colors hover:bg-violet-50 dark:border-violet-700 dark:bg-violet-950/50 dark:text-violet-300 dark:hover:bg-violet-900/40"
                >
                  {action.actionLabel}
                </button>
              )}
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default DataflowCopilot;
